import { type FC, type ReactElement } from 'react'
import { Navigate } from 'react-router-dom'
import { useCustomWorkflowsEnabled } from '../../common/useCustomWorkflowsEnabled'

export const CustomWorkflowsGuard: FC<{ children: ReactElement }> = ({ children }) => {
  const { enabled, isLoading } = useCustomWorkflowsEnabled()

  if (isLoading) {
    return null
  }
  if (!enabled) {
    return <Navigate to='/workspace' replace />
  }
  return children
}
